import { Injectable } from '@angular/core'
import { CreateRecordModel, RecordCellModel } from '../models'
import { Logger } from '@services/logger/logger'

export type FieldValue = { fieldGuid: string; value: string }

@Logger()
@Injectable({
    providedIn: 'root',
})
/**
 * Builds the payloads used by create-record websocket requests.
 */
export class CrudRecordModelFactoryService {
    /**
     * Wraps raw record cells into the backend create-record contract.
     */
    prepareCreateModel(
        parent_sot_guid: string,
        solution_object_type_guid: string,
        workspaces_guid: string[],
        cells: RecordCellModel[],
    ) {
        return {
            parent_sot_guid,
            solution_object_type_guid,
            workspaces_guid,
            cells,
        }
    }

    /**
     * Converts simple field-value pairs into create-record cells before building the payload.
     */
    prepareCreateModelWithFields(
        parent_sot_guid: string,
        solution_object_type_guid: string,
        workspaces_guid: string[],
        fields: FieldValue[],
    ): CreateRecordModel {
        const cells = fields.map(({ fieldGuid, value }) =>
            this.generateResponseCell(fieldGuid, value),
        )
        return this.prepareCreateModel(
            parent_sot_guid,
            solution_object_type_guid,
            workspaces_guid,
            cells,
        )
    }

    /**
     * Creates a minimal editable cell object for create-record requests.
     */
    generateResponseCell(fieldGuid: string, value: string) {
        return {
            value: value,
            revision: '0',
            field_guid: fieldGuid,
        }
    }
}
